import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BaseApiService } from './base.service';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class FeedbackService extends BaseApiService {

  constructor(http: HttpClient) {
    super(http, 'feedback');
  }

  public sendFeedback(messageId: string, feedbackType: 'positive' | 'negative'): Observable<any> {
    const params = { type: feedbackType, source: 'user' };
    return this._http.post<any>(`${this._baseUrl}/${messageId}`, params);
  }

}

